import React from 'react';

export const DBullets = ({
    text,
    children,
    delimiter = '*',
    ordered = false,
    className,
    style,
    itemClassName,
    itemStyle,
  }) => {
    // Source string: prefer text prop; fallback to string children
    let source = '';
    if (typeof text === 'string') source = text;
    else if (typeof children === 'string') source = children;
    else if (children) {
      const parts = React.Children.toArray(children);
      if (parts.every(p => typeof p === 'string')) source = parts.join('');
    }
    const items = source
      .split(delimiter)
      .map(s => s.trim())
      .filter(Boolean);
    const List = ordered ? 'ol' : 'ul';
    if (items.length === 0) {
      return null;
    }
    return (
      <List className={className} style={style}>
        {items.map((item, idx) => (
          <li key={idx} className={itemClassName} style={itemStyle}>
            {item}
          </li>
        ))}
      </List>
    );
  };
 

export default DBullets;

